// Mobile
export const isAndroidMobile = () => /Android/i.test(navigator.userAgent);
export const isBlackBerryMobile = () => /BlackBerry/i.test(navigator.userAgent);
export const isIOSMobile = () => (
  /iPad|iPhone|iPod/.test(navigator.platform) || /iPhone|iPad|iPod/i.test(navigator.userAgent)
) || (navigator.maxTouchPoints && navigator.maxTouchPoints > 2 && /MacIntel/.test(navigator.platform));

export const isOperaMobile = () => /Opera Mini/i.test(navigator.userAgent);
export const isWindowsMobile = () => /IEMobile|WPDesktop/i.test(navigator.userAgent);
export const isAnyMobile = () =>
  isAndroidMobile() || isBlackBerryMobile() || isIOSMobile() || isOperaMobile() || isWindowsMobile();

// Desktop
export const isIE =
  navigator.appName === 'Microsoft Internet Explorer' || /Trident|rv:11|MSIE/.test(navigator.userAgent);

// Mobile and desktop
export const isIOS = () =>
  (/safari/i.test(navigator.userAgent) && !/chrome/i.test(navigator.userAgent)) || isIOSMobile();
